export const translations = {
  limparFiltro: {
    pt: "Limpar Filtro",
    en: "Clear Filter",
    de: "Klarfilter",
    es: "Filtro limpio",
  },
  obrigatorio: {
    pt: "Obrigtório",
    en: "Mandatory",
    de: "Verpflichtend",
    es: "Obligatorio",
  },
  cancelar: {
    pt: "Cancelar",
    en: "Cancel",
    de: "kündiger",
    es: "Cancelar",
  },
  selecione: {
    pt: "Selecione...",
    en: "Select...",
    de: "Auswählen...",
    es: "Seleccione...",
  },
  configuracoes: {
    pt: "Configurações",
    en: "Settings",
    de: "Einstellungen",
    es: "Configuración",
  },
  cadastrar: {
    pt: "Cadastrar",
    en: "Register",
    de: "Katastern",
    es: "Register",
  },
  voltar: {
    pt: "Voltar",
    en: "Go back",
    de: "Geh zurück",
    es: "Regresa",
  },
  title: {
    pt: "Cadastro RTV",
    en: "RTV Registration",
    de: "RTV-Registrierung",
    es: "Registro RTV",
  },

  regional: {
    pt: "Regional",
    en: "Regional",
    de: "Regional",
    es: "Regional",
  },

  rtv: {
    pt: "Código RTV",
    en: "RTV Code",
    de: "RTV-Code",
    es: "Código RTV",
  },
  rtv_gr: {
    pt: "RTV/GR",
    en: "RTV/GR",
    de: "RTV/GR",
    es: "RTV/GR",
  },
};
